import PolicyRepository from "../repository/policy-repository"

class PolicyService 
{
    #policyRepository;

    constructor() {
        this.#policyRepository = new PolicyRepository();
    }

    async findAllTransactionRulesByRoleId(roleId) {
        try {
            const data = await this.#policyRepository.getTransactionRulesByRoleId(roleId);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async saveTransactionRulesByRoleId(roleId, rules) {
        try {
            const data = await this.#policyRepository.updateTransactionRulesByRoleId(roleId, rules);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

}
export default PolicyService;